import React from 'react';

export const Border = () => (
    <>
        <rect x="2" y="2" width="20" height="20" rx="1" fill="white" stroke="black" stroke-linejoin="round"/>
        <rect x="5" y="5" width="14" height="14" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4 3"/>
    </>
);